import { useEffect, useState } from "react";
import { getOverview } from "services/analytics-truth.service";
import { isCustomRangeIncomplete } from "utils/analyticsQueryParams";

const EMPTY_KPIS = {
  totalRevenue: 0,
  totalExpenses: 0,
  totalCommissions: 0,
  totalLeads: 0,
  leadsThisMonth: 0,
  vslOptInSubmissions: 0,
  conversionRate: null,
  topTrafficSource: null,
  netProfit: 0,
  salesCount: 0,
  mrr: 0,
};

export default function useAnalyticsDashboard(api, filters) {
  const [kpis, setKpis] = useState(EMPTY_KPIS);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isCustomRangeIncomplete(filters)) {
      setIsLoading(false);
      setKpis(EMPTY_KPIS);
      setError(null);
      return;
    }

    let cancelled = false;

    const load = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const overview = await getOverview(api, { filters });
        if (cancelled) return;

        setKpis({
          totalRevenue: overview?.totalRevenue ?? 0,
          totalExpenses: overview?.totalExpenses ?? 0,
          totalCommissions: overview?.totalCommissions ?? 0,
          totalLeads: overview?.totalLeads ?? 0,
          leadsThisMonth: overview?.leadsThisMonth ?? 0,
          vslOptInSubmissions: overview?.vslOptInSubmissions ?? 0,
          conversionRate: overview?.conversionRate ?? null,
          topTrafficSource: overview?.topTrafficSource ?? null,
          netProfit: overview?.netProfit ?? 0,
          salesCount: overview?.salesCount ?? 0,
          mrr: overview?.mrr ?? 0,
        });
        setError(null);
      } catch {
        if (!cancelled) {
          setKpis(EMPTY_KPIS);
          setError("Failed to load dashboard KPIs.");
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [api, filters.dateRangeType, filters.customDateRange?.[0], filters.customDateRange?.[1]]);

  return { kpis, isLoading, error };
}
